import React from 'react';
import PropTypes from 'prop-types';
import { Container } from 'mdbreact';
import { FormattedMessage } from 'react-intl';

const TitleHeader = ({
    title,
    icon,
    values,
    children,
    actions,
    subtitle,
    className = '',
}) => {
    return (
        <Container fluid className="full-width title-header">
            <div className={`title-header__body ${className}`}>
                <div className="title-header__body__container">
                    <div className="title-header__top">
                        <div className="title-header__title-block">
                            <h1 className="title-header__title">
                                <img src={icon} alt="icon" />{' '}
                                <span>
                                    <FormattedMessage
                                        id={title}
                                        values={values}
                                    />
                                </span>
                            </h1>
                        </div>
                        {actions}
                    </div>
                    {children && children}
                </div>
            </div>
        </Container>
    );
};

TitleHeader.propTypes = {
    children: PropTypes.any,
    actions: PropTypes.node,
    icon: PropTypes.string,
    title: PropTypes.string,
    subtitle: PropTypes.string,
    values: PropTypes.object,
};

export default TitleHeader;
